import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Class which contains custom validations for form controls.
 * Consists validations for RegEx check for password constraints.
 */
export class CustomValidator {

  /**
   * Validate a given value against the given regular expression.
   * @param regex patten to match
   * @param error error returned when the match failed
   */
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }
}
